import script from "./CobroVentaRapidaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CobroVentaRapidaView.vue?vue&type=script&setup=true&lang=js"

import "./CobroVentaRapidaView.vue?vue&type=style&index=0&id=38ab30bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ab30bc"]])

export default __exports__